import {ShopPageTitle} from "../shop/_components/ShopPageTitle";
import React, {useMemo} from "react";
import {Button, Col, Form, Row} from "react-bootstrap";
import {Link, Navigate, useNavigate} from "react-router-dom";
import {useAuth} from "../../context";
import {useCarrierList} from "../backend2/admin/carrier/useCarrier";
import {useAddressDetails} from "../backend2/address/useAddress";
import {CheckoutProgress} from "../shop/_components/CheckoutProgress";
import {useBasket} from "../shop/useShop";
import {Formik, Form as FormikForm} from "formik";
import * as yup from "yup";
import {OurClearAlert} from "../_components";
import {OrderSummary} from "../shop/_components/OrderSummary";
import {getPriceWithVat} from "../../utils2";

export function DeliveryMethod() {
    const {userId, bskToken, user} = useAuth()
    const navigate = useNavigate();
    const {basket, editArticle, errorArticle, loadingArticle, clearErrorArticle} = useBasket()
    const {list: carrierList, loadingList: loadingCarrierList, errorList: errorCarrierList, clearErrorList: clearErrorCarrierList} = useCarrierList()
    const {value: addressValue, loadingValue: loadingAddress, errorValue: errorAddress, clearError: clearErrorAddress} = useAddressDetails(basket?.address_id, userId)
    const filteredCarriers = useMemo(() => carrierList.filter(carrier => carrier.countries.some(country => addressValue.country === country.code)), [carrierList, addressValue])

    const validationSchema = yup.object().shape({
        carrier_id: yup.string().required("Select a valid delivery method.")
    })

    function handleSubmit(values, actions) {
        editArticle(values)
            .then(() => navigate("/checkout/payment"))
            .catch(console.warn)
            .finally(() => actions.setSubmitting(false))
    }

    const goBack = "/checkout/address"

    if (!bskToken || (loadingArticle === false && basket.articles.length === 0)) {
        return <Navigate to="/shop"/>
    }

    if (basket && basket.address_id == null) {
        return <Navigate to="/checkout/address"/>
    }

    return (
        <>
            <CheckoutProgress/>

            <ShopPageTitle title="Delivery Method"/>

            <Formik validationSchema={validationSchema} initialValues={basket} onSubmit={handleSubmit} enableReinitialize={true}>
                {({isSubmitting, values, setFieldValue, errors, touched}) => (
                    <FormikForm>

                        <OurClearAlert variant="danger" msg={errorArticle} onClear={clearErrorArticle}/>
                        <OurClearAlert variant="danger" msg={errorCarrierList} onClear={clearErrorCarrierList}/>
                        <OurClearAlert variant="danger" msg={errorAddress} onClear={clearErrorAddress}/>

                        <Row>
                            <Col md={8}>
                                <div>Select a delivery method:</div>
                                {(loadingCarrierList || loadingAddress) ?
                                    <LoadingRadioButton/>
                                    :
                                    filteredCarriers && filteredCarriers.length > 0 ?
                                        <>
                                            <CarrierList list={filteredCarriers} setFieldValue={setFieldValue} selectedCarrier={values.carrier_id}/>
                                            {errors.carrier_id && touched.carrier_id && <div className="text-danger">{errors.carrier_id}</div>}
                                            {user?.vat_percentage > 0 ? <div>* VAT included at {user?.vat_percentage}% estimated on your primary address.</div> :
                                                <div>* VAT will be calculated based on your billing address at checkout.</div>}
                                        </>
                                        :
                                        <option disabled value="">No options available</option>
                                }
                            </Col>

                            <Col>
                                <OrderSummary basket={basket} disabled={isSubmitting} className="d-none d-md-block"/>
                                <div className="d-flex justify-content-end">
                                    <Button as={Link} variant="link" to={goBack}>Go back</Button>
                                    <Button variant="success" type="submit" className="d-md-none" disabled={isSubmitting}>Continue</Button>
                                </div>
                            </Col>
                        </Row>
                    </FormikForm>
                )}
            </Formik>

        </>
    )
}

function LoadingRadioButton() {
    return <Form.Check type="radio" label="Loading..." name="flexRadioCarrier" id="loading" disabled/>
}

function CarrierList({list, setFieldValue, selectedCarrier}) {
    const {user} = useAuth()

    return list.map((item, index) => (
        <div key={index} className="d-flex flex-wrap align-items-top gap-2 my-2">
            <Form.Check
                type="radio"
                label={`${item.company}, ${item.name} € ${getPriceWithVat(item.price, user?.vat_percentage)}`}
                name="flexRadioCarrier"
                id={`flexRadioDefaultCarrier${index}`}
                onChange={() => setFieldValue("carrier_id", item.id)}
                checked={selectedCarrier === item.id}
            />
        </div>
    ))
}
